import React from 'react';
import { CheckIcon, UsersIcon, HeadphonesIcon, ClipboardCheckIcon } from 'lucide-react';
const AboutPage = () => {
  return <div data-id="element-163">
      {/* Hero Section */}
      <section className="bg-[#0a3d62] text-white py-16" data-id="element-164">
        <div className="container mx-auto px-4" data-id="element-165">
          <div className="max-w-3xl mx-auto text-center" data-id="element-166">
            <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-167">
              About PinnacleHub
            </h1>
            <p className="text-lg text-gray-200" data-id="element-168">
              Your trusted partner for appliance repairs and maintenance across
              the UK
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-169">
        <div className="container mx-auto px-4" data-id="element-170">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-171">
            <div data-id="element-172">
              <h2 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-173">
                Who We Are
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-174">
                Welcome to PinnacleHub, where we specialise in fast,
                professional appliance repairs and service plans across the UK.
                From kitchens to living rooms, our trusted engineers are here to
                help with all your appliance needs.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-175">
                Founded on the principles of reliability, transparency, and
                exceptional service, we've built a reputation for solving
                appliance problems quickly and effectively. Our team of
                qualified engineers brings years of experience and expertise to
                every job, ensuring your appliances are in safe hands.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-176">
                We understand how disruptive appliance breakdowns can be to your
                daily routine. That's why we offer fixed-price support, UK-based
                service, and peace of mind for every home through our
                comprehensive service plans.
              </p>
              <div className="space-y-4 mt-8" data-id="element-177">
                <div className="flex items-start" data-id="element-178">
                  <CheckIcon className="text-[#3fc1c9] mr-3 mt-1" size={20} data-id="element-179" />
                  <div data-id="element-180">
                    <h3 className="font-medium text-[#0a3d62]" data-id="element-181">
                      Experienced Engineers
                    </h3>
                    <p className="text-gray-600" data-id="element-182">
                      All our technicians are fully qualified and regularly
                      trained on the latest appliance technologies.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-183">
                  <CheckIcon className="text-[#3fc1c9] mr-3 mt-1" size={20} data-id="element-184" />
                  <div data-id="element-185">
                    <h3 className="font-medium text-[#0a3d62]" data-id="element-186">
                      Nationwide Coverage
                    </h3>
                    <p className="text-gray-600" data-id="element-187">
                      We provide repair services throughout the UK, ensuring
                      help is never far away.
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-188">
                  <CheckIcon className="text-[#3fc1c9] mr-3 mt-1" size={20} data-id="element-189" />
                  <div data-id="element-190">
                    <h3 className="font-medium text-[#0a3d62]" data-id="element-191">
                      Transparent Pricing
                    </h3>
                    <p className="text-gray-600" data-id="element-192">
                      Our service plans offer clear, upfront pricing with no
                      hidden costs or surprises.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="order-first md:order-last" data-id="element-193">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tWURPZjGsUmMquL9s1Fawk/04._Washing_Machine.png" alt="Modern washing machines with laundry basket" className="rounded-lg shadow-lg w-full h-auto" data-id="element-194" />
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="py-16 bg-gray-50" data-id="element-195">
        <div className="container mx-auto px-4" data-id="element-196">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-197">
            <h2 className="text-3xl font-bold text-[#0a3d62] mb-4" data-id="element-198">
              Our Values
            </h2>
            <p className="text-gray-600" data-id="element-199">
              At PinnacleHub, our core values guide everything we do
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-200">
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-201">
              <div className="bg-[#e6f7f8] p-4 rounded-full inline-flex mb-4" data-id="element-202">
                <UsersIcon size={24} className="text-[#0a3d62]" data-id="element-203" />
              </div>
              <h3 className="text-xl font-semibold text-[#0a3d62] mb-3" data-id="element-204">
                Customer First
              </h3>
              <p className="text-gray-600" data-id="element-205">
                We prioritise your needs and convenience, ensuring a positive
                experience from the first contact to job completion.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-206">
              <div className="bg-[#e6f7f8] p-4 rounded-full inline-flex mb-4" data-id="element-207">
                <HeadphonesIcon size={24} className="text-[#0a3d62]" data-id="element-208" />
              </div>
              <h3 className="text-xl font-semibold text-[#0a3d62] mb-3" data-id="element-209">
                Responsive Support
              </h3>
              <p className="text-gray-600" data-id="element-210">
                Our UK-based support team is always ready to assist with
                queries, bookings, and follow-up care.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-211">
              <div className="bg-[#e6f7f8] p-4 rounded-full inline-flex mb-4" data-id="element-212">
                <ClipboardCheckIcon size={24} className="text-[#0a3d62]" data-id="element-213" />
              </div>
              <h3 className="text-xl font-semibold text-[#0a3d62] mb-3" data-id="element-214">
                Quality Assurance
              </h3>
              <p className="text-gray-600" data-id="element-215">
                We stand behind our work with a commitment to excellence and
                attention to detail on every job.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default AboutPage;